import React from 'react';
import { motion } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { Button } from '../ui/Button';
import { ChevronRightIcon, ClockIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
export function Step1Welcome() {
  const {
    setCurrentStep
  } = useIntake();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto" data-id="element-313" data-mp="1io478pm5ixcq">
      <div className="text-center mb-10" data-id="element-314" data-mp="19qk2v7szskxw">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white shadow-lg border-4 border-white mb-6 overflow-hidden" data-id="element-315" data-mp="v0cgwi3s0jsg">
          <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden" className="w-full h-full object-cover" data-id="element-316" data-mp="zwjr4n37ghg7" />
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 tracking-tight" data-id="element-317" data-mp="2od30y98q88n">
          Welkom bij uw project intake
        </h1>
        <p className="text-base text-gray-500 max-w-xl mx-auto leading-relaxed" data-id="element-318" data-mp="3ttuvrozn8bfq">
          Leuk dat u kiest voor Noord Digital! Om uw nieuwe website perfect aan
          te laten sluiten bij uw wensen, hebben we wat informatie nodig.
        </p>
      </div>

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 md:p-10 mb-8" data-id="element-319" data-mp="3g2zw93b1b6ot">
        <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-320" data-mp="3b46dowgw4phs">
          Wat kunt u verwachten?
        </h2>

        <div className="grid gap-4 md:grid-cols-3 mb-8" data-id="element-321" data-mp="3pssxpbhgq5fc">
          <div className="flex flex-col items-center text-center p-5 rounded-2xl bg-[#F7F8FA]" data-id="element-322" data-mp="3pudqowo4pgb3">
            <div className="w-10 h-10 rounded-full bg-[#E6F2FF] text-[#007AFF] flex items-center justify-center mb-3" data-id="element-323" data-mp="3l11fbo8gn60a">
              <ClockIcon className="w-5 h-5" data-id="element-324" data-mp="2xaf6huqmthp8" />
            </div>
            <h3 className="font-semibold text-gray-900 text-sm mb-1" data-id="element-325" data-mp="2sd5kkp2gbo65">
              ± 15 minuten
            </h3>
            <p className="text-xs text-gray-500 leading-relaxed" data-id="element-326" data-mp="3i1kh4knnq1dh">
              Neem even de tijd. U kunt altijd later informatie nasturen.
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-5 rounded-2xl bg-[#F7F8FA]" data-id="element-327" data-mp="3qv5x27bk5ooh">
            <div className="w-10 h-10 rounded-full bg-[#E6F2FF] text-[#007AFF] flex items-center justify-center mb-3" data-id="element-328" data-mp="3vs60eah0wdbw">
              <SparklesIcon className="w-5 h-5" data-id="element-329" data-mp="2z4jaywid9v7y" />
            </div>
            <h3 className="font-semibold text-gray-900 text-sm mb-1" data-id="element-330" data-mp="333s35wxrdl1e">
              Alles op één plek
            </h3>
            <p className="text-xs text-gray-500 leading-relaxed" data-id="element-331" data-mp="382v9rltdzzbh">
              Van bedrijfsgegevens tot design wensen en functionaliteiten.
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-5 rounded-2xl bg-[#F7F8FA]" data-id="element-332" data-mp="ne75lc5sexzz">
            <div className="w-10 h-10 rounded-full bg-[#E6F2FF] text-[#007AFF] flex items-center justify-center mb-3" data-id="element-333" data-mp="sbz5otgl5qf9">
              <ShieldCheckIcon className="w-5 h-5" data-id="element-334" data-mp="2cthx5mblu2vy" />
            </div>
            <h3 className="font-semibold text-gray-900 text-sm mb-1" data-id="element-335" data-mp="27uwt1bt8ez28">
              Veilig opgeslagen
            </h3>
            <p className="text-xs text-gray-500 leading-relaxed" data-id="element-336" data-mp="233oj8enzpboj">
              Uw gegevens worden vertrouwelijk en veilig verwerkt.
            </p>
          </div>
        </div>

        <div className="bg-amber-50 border-l-4 border-amber-400 p-4 rounded-r-xl mb-8" data-id="element-337" data-mp="1u3rygo4q0wyr">
          <p className="text-sm text-amber-800" data-id="element-338" data-mp="1p4ypn90dpu4x">
            <strong data-id="element-339" data-mp="1p3dr78ay1r1s">Tip van Norden:</strong> Heeft u bepaalde documenten of
            teksten nog niet? Geen probleem! U kunt in het formulier aangeven
            dat u deze later aanlevert.
          </p>
        </div>

        <Button size="lg" fullWidth onClick={() => setCurrentStep(2)} className="py-4" data-id="element-340" data-mp="1f8vlxypvpnfv">
          Start de intake
          <ChevronRightIcon className="w-5 h-5 ml-2" data-id="element-341" data-mp="39lv86aorlfw4" />
        </Button>
      </div>
    </motion.div>;
}